import type { ContractIncomeProtectionResponse } from '~/domain/IncomeProtection/contractIncomeProtection';
import type { ContractIncomeProtectionResponseDTO } from '~/dto/IncomeProtection/contractIncomeProtection';

export const contractIncomeProtectionDTOToContractIncomeProtection = ({
  resultData: resultDataDto,
  message,
  errors,
  success,
}: ContractIncomeProtectionResponseDTO): ContractIncomeProtectionResponse => {
  const resultData = resultDataDto
    ? {
        certificateCode: resultDataDto.codigoCertificado,
        insuredDocument: resultDataDto.cpfCnpjSegurado,
        productCode: resultDataDto.codigoProduto,
        companyDocument: resultDataDto.cnpjEmpresa,
        luckySeries: resultDataDto.serieSorte,
        luckyNumber: resultDataDto.numeroSorte,
        policyNumber: resultDataDto.numeroApolice,
      }
    : undefined;

  return {
    resultData,
    message,
    success,
    errors: errors.map((error) => ({
      code: error.errorCode,
      message: error.errorMessage,
    })),
  };
};
